




























































































































































































































































































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';

export default defineComponent({
  name: 'QueensLab5_ReportSheet1',
  components: {FileUploadUiComponent, StembleLatex, TableInput, CalculationInput},
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        rows: [
          {
            pressure: '',
            volume: '',
            pTimesV: '',
            pDivV: '',
          },
          {
            pressure: '',
            volume: '',
            pTimesV: '',
            pDivV: '',
          },
          {
            pressure: '',
            volume: '',
            pTimesV: '',
            pDivV: '',
          },
        ],
        PTemp1: null,
        TinCTemp1: null,
        TinKTemp1: null,
        PtimesTTemp1: null,
        PdivTTemp1: null,

        PTemp2: null,
        TinCTemp2: null,
        TinKTemp2: null,
        PtimesTTemp2: null,
        PdivTTemp2: null,

        PTemp3: null,
        TinCTemp3: null,
        TinKTemp3: null,
        PtimesTTemp3: null,
        PdivTTemp3: null,

        PTemp4: null,
        TinCTemp4: null,
        TinKTemp4: null,
        PtimesTTemp4: null,
        PdivTTemp4: null,

        massNaHCO3: null,
        uncMassNaHCO3: null,
        unitMassNaHCO3: null,

        volumeFlask: null,
        uncVolumeFlask: null,
        unitVolumeFlask: null,

        tempInitial: null,
        uncTempInitial: null,
        unitTempInitial: null,

        tempFinal: null,
        uncTempFinal: null,
        unitTempFinal: null,

        pressureInitial: null,
        uncPressureInitial: null,
        unitPressureInitial: null,

        pressureFinal: null,
        uncPressureFinal: null,
        unitPressureFinal: null,

        sampleCalc: null,
      },
      columns: [
        {label: 'Pressure (kPa)', component: CalculationInput, prop: 'pressure', width: '25%'},
        {
          label: 'Volume (mL)',
          component: CalculationInput,
          prop: 'volume',
          width: '25%',
        },
        {
          label: 'P x V',
          component: CalculationInput,
          prop: 'pTimesV',
          width: '25%',
        },
        {
          label: 'P / V',
          component: CalculationInput,
          prop: 'pDivV',
          width: '25%',
        },
      ],
    };
  },
});
